export class StepInfo {
  public ID: string = '';
  public title: string = '';
  public formName: string = '';
  public desc: string = '';
  public stepNumber?: number = 0;
  public btnText?: string = 'NEXT';
  public isDisabled?: () => boolean = () => false;
  constructor(init?: Partial<StepInfo>) {
    Object.assign(this, init);
  }
}
